import SvgIcon from "../../../../parts/SvgIcon";
import ToolTip from "../../../../parts/tooltip-portal";

const StatCard = ({
  title,
  tooltipText,
  graphTooltip,
  current,
  previous,
  chartClass,
}) => {
  const percentDiff =
    previous === 0 ? 0 : ((current / previous - 1) * 100).toFixed(2);
  // const notShowGraphic = current === 0 && previous === 0 && percentDiff === 0;
  return (
    <article className="stat-card">
      <div className="tooltip-section">
        <ToolTip body={[tooltipText]}>
          <SvgIcon src="/img/new-icons/question-circle.svg" />
        </ToolTip>
      </div>
      <header>
        <p>
          <b>{title}</b>
        </p>
      </header>
      <div className="body">
        <div className="stats">
          <div className="row">
            <h1>{current}</h1>
            <p className="p1">from {previous}</p>
          </div>
          <div className="row">
            <p
              className={`s1 percent ${
                percentDiff === 0 ? "" : percentDiff > 0 ? "up" : "down"
              }`}
            >
              {percentDiff !== 0 && (
                <SvgIcon
                  src={
                    percentDiff === 0
                      ? ""
                      : percentDiff > 0
                      ? "/img/new-icons/green-arrow-up.svg"
                      : "/img/new-icons/red-arrow-down.svg"
                  }
                  noFilterOnLight={true}
                />
              )}
              {percentDiff}%
            </p>
          </div>
        </div>
        <div className="graph-wrapper">
          <div className={`${chartClass} chart`}></div>
          <div
            className="graph-tooltip animate__animated animate__fadeInUp"
            style={
              graphTooltip.show
                ? {
                    top: graphTooltip.y,
                    left: graphTooltip.x,
                    display: "block",
                    position: "absolute",
                  }
                : {
                    display: "none",
                  }
            }
          >
            {graphTooltip.content}
          </div>
        </div>
      </div>
    </article>
  );
};

export default StatCard;
